
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/digital-executor",
      function () {
        return require("private-next-pages/digital-executor.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/digital-executor"])
      });
    }
  